export const PL_COMMIT = 'PL_Commit';
export const QUARTER_INFO = 'QUARTER_INFO';
export const GCSP_QUARTER_INFO = 'GCSP_QUARTER_INFO';
export const YEAR_WISE_DATA = 'YEAR_WISE_DATA';
export const QUARTERLY_OP_DETAILS = 'QUARTERLY_OP_DETAILS';
export const MODAL_TRIGGER = 'MODAL_TRIGGER';
export const PRIVACY_MODAL = 'PRIVACY_MODAL';
export const PL_OPPS_DETAILS_MODAL = 'PL_OPPS_DETAILS_MODAL';
export const GCSP_OPPS_DETAILS_MODAL = 'GCSP_OPPS_DETAILS_MODAL';
export const PL_COMMENT_MODAL = 'PL_COMMENT_MODAL';
export const GCSP_COMMENT_MODAL = 'GCSP_COMMENT_MODAL';
export const PL_OPPS_NAME_DETAILS_WARNING_MODAL = 'PL_OPPS_NAME_DETAILS_WARNING_MODAL';
export const GCSP_OPPS_DETAILS_WARNING_MODAL = 'GCSP_OPPS_DETAILS_WARNING_MODAL';
export const PL_COMMENT_WARNING_MODAL = 'PL_COMMENT_WARNING_MODAL';
export const GCSP_COMMENT_WARNING_MODAL = 'GCSP_COMMENT_WARNING_MODAL';
export const PL_SUBMIT_SUCCESS_MODAL = 'PL_SUBMIT_SUCCESS_MODAL';
export const PL_FAILURE_CONFIRMATION_MODAL = 'PL_FAILURE_CONFIRMATION_MODAL';
export const GCSP_OPP_VIEW = 'GCSP_OPP_VIEW';
export const RECOIL_SELECTED_ACCOUNT_STATE = 'RECOIL_SELECTED_ACCOUNT_STATE';
export const CURRENT_USER = 'CURRENT_USER';
export const ACCOUNT_LIST = 'ACCOUNT_LIST';
export const GCSP_ACTIVE_TAB_STATE = 'GCSP_ACTIVE_TAB_STATE';
export const ACTIVE_TAB_GCSP = 'ACTIVE_TAB_GCSP';
export const RECOIL_ALL_ACCOUNTS_QUARTER_STATE = 'RECOIL_ALL_ACCOUNTS_QUARTER_STATE';
export const GCSP_PAST_OPP_VIEW = 'GCSP_PAST_OPP_VIEW';
export const PURSUIT_LEADER_TABLE_ROW_DATA = 'PURSUIT_LEADER_TABLE_ROW_DATA';
export const DASHBOARD_PROFILE_DETAILS = 'DASHBOARD_PROFILE_DETAILS';
export const SUMMARY_DRAWER_TOGGLE = 'SUMMARY_DRAWER_TOGGLE';
export const SYSTEM_DATE_TIME = 'SYSTEM_DATE_TIME';
export const NOW_NEXT_BEYOND_SIDEBAR_DATA_STATE = 'NOW_NEXT_BEYOND_SIDEBAR_DATA_STATE';
export const ALL_MONTH_DATA = 'ALL_MONTH_DATA';
export const NEXT_BUTTON_ACTIVE = 'NEXT_BUTTON_ACTIVE';
export const OPERATING_SYSTEM = 'OPERATING_SYSTEM';
export const REFRESH_PL_SIDEBAR_DATA = 'REFRESH_PL_SIDEBAR_DATA';
export const TRIGGER_UPDATE_PL_SIDEBAR_DATA = 'TRIGGER_UPDATE_PL_SIDEBAR_DATA';
export const PL_SIDEBAR_UPDATE_OPP_PAYLOAD = 'PL_SIDEBAR_UPDATE_OPP_PAYLOAD';
export const SIDEBAR_EXPAND_COLLAPSE_STATE = 'SIDEBAR_EXPAND_COLLAPSE_STATE';
export const LOADING_MODAL_STATE = 'LOADING_MODAL_STATE';
